import { Typography } from '@mui/material'
import { ReactNode } from 'react'

import { Box } from './styles'

interface SectionProps {
	border?: boolean
	title?: string
	children: ReactNode
}

const Section = ({ border = true, title, children }: SectionProps) => (
	<Box borderBottom={border ? 1 : 0}>
		{title && <Typography variant="h3">{title}</Typography>}
		<Box mt={1} mb={2}>
			{children}
		</Box>
	</Box>
)

export { Section }
